var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",class:{click: _vm.click},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.text)}}),(_vm.remove)?_c('Icon',{attrs:{"icon":"arrow"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }